<template>
  <b-form-group
    label="İhracat Ülke Sayısı"
    label-for="country"
  >
    <validation-provider
      #default="{ errors }"
      name="İhracat Ülke Sayısı"
      rules="required"
    >
      <b-form-input
        id="country"
        v-model="itemData.country"
        placeholder="İhracat Ülke Sayısı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'CountryText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
